import { Flex, Form } from 'antd'

import { useTranslation } from 'react-i18next'

import { CoefficientsFields } from './CoefficientsFields'
import { ItemCategoryAFields } from './ItemCategoryAFields'
import { ItemCategoryBFields } from './ItemCategoryBFields'
import { ItemCategoryCFields } from './ItemCategoryCFields'
import { ItemCategoryDFields } from './ItemCategoryDFields'
import { ItemCategoryEFields } from './ItemCategoryEFields'
import { ItemCategoryFFields } from './ItemCategoryFFields'
import { ItemCategoryGFields } from './ItemCategoryGFields'
import { ItemCategoryHFields } from './ItemCategoryHFields'
import { ItemCategoryIFields } from './ItemCategoryIFields'
import { ItemCategoryJFields } from './ItemCategoryJFields'

import { formProps } from './utils'

type Props = {
  fieldKey: number
}

export const PropertyCategoriesFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { itemsKey, ItemCategoryProps } = formProps(t)

  const category = Form.useWatch([
    itemsKey.name,
    fieldKey,
    ItemCategoryProps.name
  ])

  const categoriesFields = {
    a: <ItemCategoryAFields fieldKey={fieldKey} />,
    b: <ItemCategoryBFields fieldKey={fieldKey} />,
    c: <ItemCategoryCFields fieldKey={fieldKey} />,
    d: <ItemCategoryDFields fieldKey={fieldKey} />,
    e: <ItemCategoryEFields fieldKey={fieldKey} />,
    f: <ItemCategoryFFields fieldKey={fieldKey} />,
    g: <ItemCategoryGFields fieldKey={fieldKey} />,
    h: <ItemCategoryHFields fieldKey={fieldKey} />,
    i: <ItemCategoryIFields fieldKey={fieldKey} />,
    j: <ItemCategoryJFields fieldKey={fieldKey} />
  }

  return (
    <Flex vertical gap={12}>
      {categoriesFields?.[category as keyof typeof categoriesFields]}

      <CoefficientsFields fieldKey={fieldKey} />
    </Flex>
  )
}
